import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  padding: 0 24px;
`;

export const Title = styled.Text`
  font-size: ${RFValue(22)}px;
  margin-bottom: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const StationsList = styled.View`
  margin: 0 -24px;
  margin-top: ${RFValue(12)}px;
`;
